import {
  GET_POS_INTEGRATIONS,
  SET_POS_INTEGRATIONS,
  API_ERROR,
  SET_POS_INTEGRATION,
  SET_POS_INTEGRATION_FILTER,
  EMPTY_POS_INTEGRATION,
  SET_POS_INTEGRATIONS_LIST,
} from './actionTypes';

const initialState = {
  posIntegrationList: [],
  posIntegrations: [],
  filter: {
    offSet: 0,
    limit: 10,
    pages: 0,
    currentPage: 1,
    query: ''
  },
  posIntegration: {
    pos_name: '',
    description: '',
  },
  error: '',
  loading: false,
};

const posIntegration = (state = initialState, action) => {
  switch (action.type) {
    case GET_POS_INTEGRATIONS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SET_POS_INTEGRATIONS:
      state = {
        ...state,
        posIntegrations: action.payload,
        loading: false,
      };
      break;
    case SET_POS_INTEGRATION:
      state = {
        ...state,
        posIntegration: {
          ...state.posIntegration,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
    case EMPTY_POS_INTEGRATION:
      state = {
        ...state,
        posIntegration: {
          ...state.posIntegration,
          pos_name: '',
          description: '',
        },
      };
      break;
      case SET_POS_INTEGRATION_FILTER:
        state = {
          ...state,
          filter: {
            ...state.filter,
            [action.payload.field]: action.payload.value,
          },
        };
        break;
      case SET_POS_INTEGRATIONS_LIST:
        state = {
          ...state,
          posIntegrationList: action.payload
        };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default posIntegration;
